import { render, staticRenderFns } from "./prize-product-table.vue?vue&type=template&id=defcf83c&scoped=true&"
import script from "./prize-product-table.vue?vue&type=script&lang=js&"
export * from "./prize-product-table.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "defcf83c",
  null
  
)

export default component.exports